import { BlockyAvatar } from '../avatars/blocky-avatar.js';
import { state } from './state.js';

/**
 * Sinh mới hoặc thay thế Avatar trong Scene
 */
export function spawnAvatar(presetId = 'CO_GAI_AO_DAI', animName = 'walk') {
  if (state.currentAvatar) {
    if (state.layerCenterGroup) {
      state.layerCenterGroup.remove(state.currentAvatar.root);
    }
    state.currentAvatar.dispose();
  }

  state.currentAvatarId = presetId;
  state.currentAnimName = animName;
  state.currentAvatar = new BlockyAvatar(presetId);
  state.currentAvatar.root.position.set(0, state.currentFloorHeight, 0);

  state.currentAvatar.root.traverse((child) => {
    if (child.isMesh && child.name !== 'BlobShadow') {
      child.castShadow = true;
      child.receiveShadow = true;
    }
  });

  if (state.layerCenterGroup) {
    state.layerCenterGroup.add(state.currentAvatar.root);
  }

  if (state.currentAvatar.animator) {
    state.currentAvatar.animator.play(animName);
  }
}
